<template>
<div id="div-keep-or-upgrade-container" class="div-lightbox-container">
    <table width="100%" align="left" border="0" cellpadding="0" cellspacing="0">
        <tr>
            <td align="right" colspan="2">
                <a href="javascript:void(0);" onclick="fToggleKeepOrUpgrade();">Close</a>
            </td>
        </tr>
        <tr>
            <td class="subhead" colspan="2">
                Keep High Speed or Upgrade to Enhanced High Speed?
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="body-copy" colspan="2">
                <p>
                    You already purchased our High Speed service and can connect another device-up to 6 total-at no extra charge. You can also upgrade all of your connected devices (up to 6) to our premium Enhanced High Speed service, offering a faster connection; you will only be charged the difference between the two plans.
                </p>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="input-field-label" colspan="2" align="center">
                <button class="button-0" style="width:400px" onclick="fChangePackageAndSubmit('42');">Upgrade all my devices to Enhanced High Speed</button>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="body-copy" colspan="2" align="center">
                <p>
                    <b>- OR -</b>
                </p>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td class="input-field-label" colspan="2" align="center">
                <button class="button-0" style="width:400px" onclick="fConfirmAndSubmit();">Connect to my current High Speed plan</button>
            </td>
        </tr>
        <tr>
            <td class="form-spacer" colspan="2">
            </td>
        </tr>
        <tr>
            <td align="right" colspan="2">


            </td>
        </tr>
        <tr>
            <td class="form-spacer">
            </td>
        </tr>
        <tr>
            <td align="left">

            </td>
        </tr>
    </table>
</div>
</template>

<script>

export default {
  name: "KeepUpgradeContainer"
}

</script>

<style scoped>

</style>